import { Component, OnInit, TemplateRef, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ParcelaPaginado, Paginacao, Parcela, LoteFatura } from 'src/app/shared/services/acordo-ressarcimento/api/models';
import { ParcelaService, LoteFaturaService } from 'src/app/shared/services/acordo-ressarcimento/api/services';
import { LoadingService } from 'src/app/shared/services/components/loading.service';
import { ConsultarLoteFaturaService } from '../consultar-lote-fatura.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-detalhe-lote-fatura',
  templateUrl: './detalhe-lote-fatura.component.html',
  styleUrls: ['./detalhe-lote-fatura.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DetalheLoteFaturaComponent implements OnInit {

  public numeroLoteFatura: number;  
  source = [];
  columnsTemplate = [];
  public lote: LoteFatura;
  private realizaPesquisa: boolean;

  @ViewChild('templateVencimento') private templateVencimento: TemplateRef<any>;
  @ViewChild('templateValor') private templateValor: TemplateRef<any>;

  constructor(
    private route: ActivatedRoute,
    public loteFaturaService: LoteFaturaService,
    public consultarLoteFaturaService: ConsultarLoteFaturaService,
    private loading: LoadingService,
    private location: Location,
    @Inject(AppComponent) public appComponent: AppComponent) { }

  public ngOnInit() {
    this.columnsTemplate = [
      { prop: 'acordo.processoRessarcimento.codigoRamoSinistro', label: 'Ramo' },
      { prop: 'acordo.processoRessarcimento.numeroSinistro', label: 'Sinistro' },
      { prop: 'acordo.processoRessarcimento.anoSinistro', label: 'Ano' },
      { prop: 'acordo.codigoAcordo', label: 'Acordo' },
      { prop: 'numeroParcela', label: 'N° parcela' },
      { label: 'Data de vencimento', template: this.templateVencimento },
      { prop: 'tipoSituacaoParcelaAcordo.nomeTipoSituacaoParcelaAcordo', label: 'Status' },
      { label: 'Valor da parcela', template: this.templateValor },
    ];

    this.numeroLoteFatura = this.route.snapshot.params['numeroLoteFatura'];
    this.recuperarDadosLoteFatura();
  }

  public recuperarDadosLoteFatura() {
    this.loading.open();
    this.loteFaturaService.obterLotePorNumero(this.numeroLoteFatura).subscribe(response => {
      this.lote = response;
      if (response.parcelaLista.parcelas != undefined) {
        this.source = response.parcelaLista.parcelas;
      }
      this.loading.close();
    }, error => {
      this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
      this.loading.close();
    });
  }

  public voltar() {
    this.consultarLoteFaturaService.setRealizaPesquisa(true);
    this.location.back();
  }

  public setRealizaPesquisa(realizaPesquisa: boolean) {
    this.realizaPesquisa = realizaPesquisa;
  }

}
